import { FiStar } from '@/components/react-icons/main';
import Skeleton from '@/components/Skeleton.jsx';
import IconV2 from '@/components/v2/IconV2';
import Wizard from '@/components/wizard/Wizard';

const CredentialWizardHeader = ({ icon, title, description, loading }) => {
  if (loading) {
    return (
      <Wizard.Header>
        <div className="credential-wizard-logo">
          <IconV2 icon={''} size={32} />
        </div>
        <Skeleton count={1} containerStyle={{ marginBottom: '8px' }} skeletonStyle={{ width: '200px', height: '23px', justifySelf: 'center' }} />
        <Skeleton count={1} containerStyle={{ marginBottom: '8px', marginTop: '-16px' }} skeletonStyle={{ width: '350px', height: '20px', justifySelf: 'center' }} />
      </Wizard.Header>
    );
  }
  return (
    <Wizard.Header>
      <div className="credential-wizard-logo">
        <IconV2 icon={icon || FiStar} size={32} />
      </div>
      <Wizard.Title>{title}</Wizard.Title>
      <Wizard.Description>{description}</Wizard.Description>
    </Wizard.Header>
  );
};

export default CredentialWizardHeader;
